import { JSX } from "react";

export const LayoutWrapper = (child: JSX.Element) => {
  return (
    <>
      <div>{child}</div>
    </>
  );
};
